import React from 'react'
import classnames from "classnames";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { addPair } from "../../actions/pairActions";
import { withRouter } from "react-router-dom";
import { toast } from 'react-toastify';
import $ from 'jquery';

import 'react-toastify/dist/ReactToastify.css';

class PairAddModal extends React.Component {

  constructor() {
    super();
    this.state = {
      box1: "",
      box2: "",
      errors: {},
      cryptoList: [],
      validation:""
    };
  }

  componentWillReceiveProps(nextProps) {

    if (nextProps.cryptoList) {
      this.setState({
        cryptoList: nextProps.cryptoList
      })
    }
    if (nextProps.errors) {
      this.setState({
        errors: nextProps.errors
      });
    }
    if (nextProps.pairdata !== undefined
      && nextProps.pairdata.pair !== undefined
      && nextProps.pairdata.pair.data !== undefined
      && nextProps.pairdata.pair.data.message !== undefined) {

      this.setState({
        errors: {

        },
        box1: "",
        box2: "",
        message: ""
      });
    }

  }

  onChange = e => {
    this.setState({ errors: {} });
    this.setState({ [e.target.id]: e.target.value });
    if(e.target.id==="box2"){
      if(e.target.value===this.state.box1){

        this.setState({validation:"Please choose different coin"})
        return false;
      }
      this.setState({validation:""})
    }
  };

  onPairAdd = e => {
    e.preventDefault();
    const newPair = {
      firstCoin: this.state.box1,
      secondCoin: this.state.box2
    };
    if(this.state.box1===this.state.box2){
      this.setState({validation:"Please choose different coin"})
      return false;
    }
    this.props.addPair(newPair, this.props.history);
  };
  showHtml = () => {
    const html = []
    this.state.cryptoList.map(function (value, i) {
      html.push(
        <>
          <option value={value._id}>{value.shortName}</option>
        </>
      );

    })
    return html;
  }
  render() {
    const { errors } = this.state;
    return (
      <div>
        <div className="modal fade" id="add-user-modal" data-reset="true" data-backdrop="static">
          <div className="modal-dialog">
            <div className="modal-content">
              <div className="modal-header">
                <h4 className="modal-title">Add Pair</h4>
                <button type="button" className="close" data-dismiss="modal">&times;</button>
              </div>
              <div className="modal-body">
                <form noValidate onSubmit={this.onPairAdd} id="add-user">
                  <div className="row">
                    <div className="col-md-6">
                      <div className='form-group'>
                        <label htmlFor="box1">First Box</label>
                        <select className="form-control" id="box1" value={this.state.box1} error={errors.box1} onChange={this.onChange}>
                          <option>Please select crypto currency</option>
                          {this.showHtml()}
                        </select>
                        <span className="text-danger">{errors.box1}</span>
                        <span className="text-danger">{errors.message}</span>
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className='form-group'>
                        <label htmlFor="box2">Second Box</label>
                        <select className="form-control" id="box2" value={this.state.box2} error={errors.box2} onChange={this.onChange}>
                          <option>Please select crypto currency</option>
                          {this.showHtml()}
                        </select>
                        <span className="text-danger">{errors.box2}</span>
                        <span className="text-danger">{this.state.validation}</span>
                      </div>
                    </div>
                  </div>
                </form>
              </div>
              <div className="modal-footer">
                <button
                  form="add-user"
                  type="submit"
                  className="btn btn-primary">
                  Save
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

PairAddModal.propTypes = {
  addPair: PropTypes.func.isRequired,
  auth: PropTypes.object.isRequired,
  pairdata: PropTypes.object.isRequired,
  errors: PropTypes.object.isRequired
};

const mapStateToProps = state => ({
  auth: state.auth,
  pairdata: state.pairdata,
  errors: state.errors
});

export default connect(
  mapStateToProps,
  { addPair }
)(withRouter(PairAddModal));
